import { httpClient } from '@/services/http/httpClient'

export type InvitePortfolioPermission = 'VIEWER' | 'ADMIN' | 'EDITOR'

export type InvitePortfolioData = {
  inviteeId: string
  portfolioId: string
  permission: string
}

export async function createPortfolioInvite({
  inviteeId,
  portfolioId,
  permission,
}: InvitePortfolioData) {
  await httpClient.post(`/projects/portfolio-invites/`, {
    inviteeId,
    permission,
    portfolioId,
  })
}
